import { useDataChange, useDataValue } from 'Simple/Data'
import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import { useMutation } from 'Data/Api.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'

import mutation from './mutation.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let ids = useDataValue({
    context: 'selected',
    path: 'procedure_ids',
    viewPath: props.viewPath,
  })
  let setProcedureIds = useDataChange({
    context: 'selected',
    path: 'procedure_ids',
    viewPath: props.viewPath,
  })
  let [, notify] = useNotifications()
  let [, executeMutation] = useMutation(mutation)
  let setFlowTo = useSetFlowTo(props.viewPath)

  return async function onSubmit({ value, originalValue, args, change }) {
    let mutationResponse = await executeMutation({
      ids,
    })
    if (mutationResponse.error) {
      notify(notifyError(`An error has occurred while deleting procedures.`))
      return
    }

    notify(notifySuccess(`Procedures deleted successfully.`))
    setProcedureIds([])

    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}
